import React from 'react';
import Flexbox from 'flexbox-react';
import { inject, observer } from 'mobx-react';
import TemplateManageStatusFlagRow from './TemplateManageStatusFlagRow';
import SimpleTableHeader from '../shared/SimpleTableHeader';
import _ from 'lodash';

@inject('TemplateStore')
@observer
export default class TemplateManageStatusFlags extends React.Component {
  handleColumnSort(column) {
    this.props.TemplateStore.setStatusFlagSortParams(
      column.id,
      column.sortDir
    );
  }

  render() {
    return (
      <Flexbox flexDirection="column">
        <p>{I18n.t('js.manage_status_flags_description')}</p>
        <table className="bp3-html-table bp3-html-table-striped bp3-small full-table">
          <thead>
            <SimpleTableHeader
              columns={this.props.TemplateStore.statusFlagColumns}
              handleColumnSort={this.handleColumnSort.bind(this)}
            />
          </thead>
          <tbody>
            {_.map(
              this.props.TemplateStore.statusFlags,
              statusFlag => (
                <TemplateManageStatusFlagRow
                  key={statusFlag.id}
                  statusFlag={statusFlag}
                />
              )
            )}
          </tbody>
        </table>
      </Flexbox>
    );
  }
}
